import * as React from "react";
import { useDispatch } from "react-redux";
import { TextField, Typography } from "@material-ui/core";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
var Feedback = function (_a) {
  var item = _a.item;
  var dispatch = useDispatch();
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var handleTextDataChange = function (e) {
    return dispatch(quizAnswerActions.changeTextData(item.id, e.currentTarget.value));
  };
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var itemTitle = item.title;
  var itemBody = item.body;
  var itemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer && quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var textData = itemAnswer ? itemAnswer.textData : "";
  return React.createElement("div", {
    style: {
      marginBottom: 10
    }
  }, React.createElement(MarkdownText, {
    Component: Typography,
    variant: "subtitle1",
    variantMapping: {
      subtitle1: "p"
    }
  }, itemTitle), React.createElement(MarkdownText, {
    Component: Typography
  }, itemBody), answerLocked ? React.createElement(Typography, {
    variant: "body1"
  }, textData) : React.createElement(TextField, {
    variant: "outlined",
    value: textData,
    onChange: handleTextDataChange,
    fullWidth: true,
    multiline: true,
    rows: 10,
    margin: "normal"
  }));
};
export default Feedback;